import React from 'react';
import { Wrapper, Text, Title, Note, Image } from './styled';

const SectionBlock = ({ text, image, note, index, active, isHorizontal, hidePriceLabel, revertDescBlocks, length, sizeMedium }) => {
    const title = <Title sizeMedium={sizeMedium} dangerouslySetInnerHTML={{ __html: text }}/>;
    const descriptionBlock = revertDescBlocks
        ? <>
            {Boolean(note) && <Note>{note}</Note>}
            {title}
        </>
        : <>
            {title}
            {Boolean(note) && <Note bottom dangerouslySetInnerHTML={{ __html: note }}/>}
        </>;
    return (
        <Wrapper length={length}>
            <Text data='text-blocks' active={active}>
                {index === 0 && !hidePriceLabel && <Note>В подарок каждый месяц</Note>}
                {descriptionBlock}
            </Text>
            <Image src={image} isHorizontal={isHorizontal} length={length}/>
        </Wrapper>
    );
};

export default SectionBlock;
